export enum AdrPacking {
  FUT = 'fût',
  BIDON = 'bidon',
  CARTON = 'carton',
  TONNEAU = 'tonneau',
  GRV = 'GRV',
  CAISSE = 'caisse',
  SAC = 'sac',
  AEROSOLS = 'aérosols',
  BOUTEILLE = 'bouteille',
  EMBALLAGE_METALLIQUE_LEGER = 'emballage métallique léger',
}
